import { User } from '@components/user/User'
import { useAppSelector } from '@store/hooks'
import { selectSelectedUser } from '@store/UserReducer'
import { Card, Col, Empty, Row, Spin } from 'antd'

const ThirdPartiesTab = () => {
  //   const mockUser: UserModel = {
  //     id: 4848,
  //     firstName: 'Test',
  //     lastName: 'User',
  //     email: 'test@example.com',
  //     phone: '1234567890',
  //     locale: 'en',
  //     sevenroomsLoyaltyRank: 1,
  //     referralCredits: 0,
  //     canUpdateProfile: true,
  //     canUpdatePicture: true,
  //     registered: [],
  //     thirdPartyProfiles: [
  //       {
  //         id: 'jzebdiojxzeopd',
  //         thirdParty: 'intercom',
  //         link: 'https://app.intercom.com/a/users/456',
  //       },
  //     ],
  //     providerProfiles: [
  //       {
  //         id: 2200,
  //         providerType: {
  //           id: 20,
  //           name: 'Rikas',
  //           venueGroupId: '95959593595',
  //           managerBaseUrl: 'https://manager.rikas.com',
  //         },
  //         providerUserId: 'user-789',
  //         providerId: 'venue-001',
  //         marketingOptinAt: '2024-01-01T12:00:00Z',
  //         lastInteractionAt: '2024-05-01T14:00:00Z',
  //       },
  //     ],
  //   }
  // ⬇️ Ligne à commenter/décommenter pour utiliser les mocks
  //const user = mockUser
  const user = useAppSelector(selectSelectedUser())

  if (!user) {
    return <Spin />
  }
  return (
    <Row gutter={[32, 32]}>
      <Col span={24}>
        {user.thirdPartyProfiles?.length == 0 &&
          user.providerProfiles?.length == 0 && (
            <Card>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={'No third party profiles attached'}
              />
            </Card>
          )}
        <Row gutter={[32, 32]}>
          {(user.providerProfiles ?? []).map((providerProfile) => (
            <Col span={12}>
              <User.ProviderCard profile={providerProfile} user={user} />
            </Col>
          ))}
          {(user.thirdPartyProfiles ?? []).map((thirdPartyProfile) => (
            <Col span={12}>
              <User.ThirdPartyCard
                key={thirdPartyProfile.id}
                profil={thirdPartyProfile}
              />
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  )
}

export default ThirdPartiesTab
